import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';
import AuthService from '../services/authService';
import { useLocation, useSearchParams } from 'react-router-dom';
import _, { isEmpty } from 'lodash';

interface AutoLoginContextProps {
  isLoggedIn: boolean;
  setIsLoggedIn: (loggedIn: boolean) => void;
}

const AutoLoginContext = createContext<AutoLoginContextProps | undefined>(undefined);

export const AutoLoginProvider = (props: PropsWithChildren) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    const pToken = searchParams.get('ptoken');
    if (!pToken) {
      localStorage.setItem('loggedIn Time', `${String(new Date())}`);
    }
    const tenantToken = searchParams.get('tenant_token');
    if (tenantToken) {
      localStorage.setItem('tenantToken', tenantToken);
    }
    const impersonateToken = searchParams.get('impersonateToken');
    const id = searchParams.get('id');
    const title = searchParams.get('title');
    const redirectURL = window.location.origin + window.location.pathname;
    const pathname = impersonateToken
      ? ''
      : title
      ? `${window.location.pathname}?id=${id}&title=${title}`
      : id
      ? `${window.location.pathname}?id=${id}`
      : `${window.location.pathname}?${queryParams}`;
    const authRoute = process.env.REACT_APP_AUTH_URL;

    const checkAutoLogin = async () => {
      const finalUrl = `${authRoute}/user-account/passwordless/login?ReturnUrl=${
        redirectURL + `?id=${id}`
      }&token=${pToken || impersonateToken}`;
      await new AuthService().passwordLessLogin(finalUrl, pathname);
    };

    if (!_.isEmpty(pToken) || !_.isEmpty(impersonateToken)) {
      checkAutoLogin();
    } else {
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <AutoLoginContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
      {isLoggedIn && props.children}
    </AutoLoginContext.Provider>
  );
};

export const useAutoLogin = (): AutoLoginContextProps => {
  const context = useContext(AutoLoginContext);
  if (context === undefined) {
    throw new Error('useAutoLogin must be used within an AutoLoginProvider');
  }
  return context;
};
